<template>
  <v-app>
    <notification-popup />
    <core-filter />

    <core-toolbar v-if="isAuthorized"/>

    <core-drawer />

    <core-view />
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import NotificationPopup from "./components/controllers/NotificationPopup";
export default {
  name: 'App',
  components: {NotificationPopup},
  computed: mapState({
    isAuthorized: state => state.credentials.isAuthorized,
    lang: state => state.selectedLang
  }),
  mounted ()
  {
    let self = this;
    self.$i18n.set(self.lang);
  },
};
</script>
<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
